module.exports = __webpack_public_path__ + "img/yuqi.d089e3c3.png";